import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/globals';
import { CoursesService } from '../../../service/courses.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';

declare var $: any;
@Component({
  selector: 'app-semesters',
  templateUrl: './semesters.component.html',
  styleUrls: ['./semesters.component.scss']
})
export class SemestersComponent implements OnInit {

  showLoader: boolean = false;
  semesters: any = [];
  currentCourseName = "";
  currentCourseId = 0;
  yearId: any;
  progressionMsg="";
  progressionUndoMsg="";
  constructor(private activatedRoute: ActivatedRoute, private academicsService: AcademicsService, private toastrService: ToastrService, public coursesService: CoursesService, public globals: Globals, private router: Router
    , public translate: TranslateService
    , public enrollmentGroupService: EnrollmentGroupService
  ) { }

  ngOnInit(): void {
    //  this.getAllTypes();
    // Listen for language change to update table
    // this.showLoader=true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.yearId = params['yearId'] || "";

        if (this.yearId != "") {
          this.getAvailableSemesters();
          // this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/academics/years']);
        }
      });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
    // this.showLoader=false;
  }

  getAvailableSemesters() {
    this.showLoader = true;
    this.enrollmentGroupService.getYearSemesters(this.yearId).subscribe(
      data => {
        this.semesters = data;
        this.updateTable();
      },
      error => {

        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false

      },
      () => this.showLoader = false
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'enarabic',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
          }
        }],
      });
    }, 1);
  }


  onProgression(semesterId:number,yearId:number) {
    this.showLoader = true;
    let username = this.globals.currentUserInfo.username;
    this.academicsService.promoteEnrolledStudents(this.globals.orgId,yearId,semesterId,username).subscribe(
      data => {
        // console.log(data);
        this.progressionMsg=this.translate.instant(data[0]);  
      },
      error => {

        this.toastrService.error(this.translate.instant('PROGRESSION_FAILS'));
        this.showLoader = false

      },
      () => this.showLoader = false
    );
  }

  onProgressionUndo(semesterId:number,yearId:number) {
    this.showLoader = true;
    let username = this.globals.currentUserInfo.username;
    this.academicsService.promoteEnrolledStudentsUndo(this.globals.orgId,yearId,semesterId,username).subscribe(
      data => {
        // console.log(data);
        this.progressionUndoMsg=this.translate.instant(data[0]);  
        
      },
      error => {

        this.toastrService.error(this.translate.instant('PROGRESSION_UNDO_FAILS'));
        this.showLoader = false

      },
      () => this.showLoader = false
    );
  }  
}

